import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePreClaimsReasonTypes } from './normalize';

export const fetchPreClaimsReasonTypes = createProvider(api.fetchPreClaimsReasonTypes)
  .andThen((res) => normalizePreClaimsReasonTypes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
